<template>
  <v-dialog
    v-model="mostrarVideo"
    :max-width="maxWidth"
    persistent
    scrollable
  >
    <v-card
      class="modal-principal"
      v-if="mostrarVideo"
    >
      <v-card-title class="titulo">
        <span>{{ tituloVideo }}</span>
        <v-spacer></v-spacer>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text
        style="height: 100%;"
        class="pa-0"
      >
        <youtube
          :video-id="videoId"
          :player-vars="videoVars"
          ref='youtube'
        ></youtube>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <botones-cancelar-guardar
          v-bind:mostrar-guardar="false"
          v-on:alCancelar="cerrar"
        ></botones-cancelar-guardar>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import BotonesCancelarGuardar from '@/components/Botones/BotonesCancelarGuardar'
export default {
  name: 'VideoAyuda',
  components: {
    BotonesCancelarGuardar
  },
  props: {
    yt_id: {
      type: String,
      default: null
    },
    vars: {
      type: Object,
      default () {
        return {}
      }
    },
    mostrar: {
      type: Boolean,
      default: false
    },
    titulo: {
      type: String,
      default: ''
    }
  },
  computed: {
    player () {
      return this.$refs.youtube.player
    },
    maxWidth () {
      return (this.vars.width ? this.vars.width : '640px')
    }
  },
  data () {
    return {
      videoId: this.yt_id,
      videoVars: this.vars,
      mostrarVideo: this.mostrar,
      tituloVideo: this.titulo
    }
  },
  methods: {
    cerrar () {
      // this.player.stopVideo()
      this.$emit('cerrar')
    }
  },
  watch: {
    yt_id (val) {
      this.videoId = val
    },
    mostrar (val) {
      this.mostrarVideo = val
    },
    titulo (val) {
      this.tituloVideo = val
    }
  }
}
</script>

<style lang="scss" scoped>
iframe {
  width: 100%;
  max-width: 650px; /* Also helpful. Optional. */
}
</style>
